document.addEventListener('DOMContentLoaded', async () => {
  let map: any;

  const headOfOffice = { lat: 53.65699924762551, lng: -2.6571880678236304 };
  const highStBranch = { lat: 53.65368782743206, lng: -2.630794035292208 };
  const leylandBranch = { lat: 53.69374733179992, lng: -2.6962272757842793 };

  //@ts-ignore
  const { Map } = await google.maps.importLibrary('maps');
  //@ts-ignore
  const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');

  map = new Map(document.getElementById('map'), {
    zoom: 14,
    center: headOfOffice,
    mapId: 'CHORLEY_MAP_ID',
  });

  new AdvancedMarkerElement({
    map: map,
    position: headOfOffice,
    title: 'Head Office Branch',
  });

  new AdvancedMarkerElement({
    map: map,
    position: highStBranch,
    title: 'High St Branch',
  });

  new AdvancedMarkerElement({
    map: map,
    position: leylandBranch,
    title: 'Leyland Branch',
  });

  document.getElementById('headOfficeLink')?.addEventListener('click', () => {
    map.panTo(headOfOffice);
  });
  document.getElementById('highStLink')?.addEventListener('click', () => {
    map.panTo(highStBranch);
  });
  document.getElementById('leylandLink')?.addEventListener('click', () => {
    map.panTo(leylandBranch);
  });
});
